/* eslint-disable react/prop-types */
import { Button, DialogContent, DialogContentText, Stack } from "@mui/material";
import DialogHeader from "./dialogHeader";
import translations from "../translations";

export default function SuccessDialog({ handleClose, profileUrl }) {
  const locale = window.authSettings ? window.authSettings.locale : "fr-FR";
  const translation = translations.getTranslations(locale);

  const handleClick = () => {
    handleClose();
    //console.log("window.location.href.includes(profileUrl)");
    //console.log(profileUrl);
    //console.log(window.location.href.includes(profileUrl));
    if (window.location.href.includes(profileUrl)) {
      console.log("Reloading");
      window.location.reload();
    } else window.location.href = `#/${profileUrl}`;
  };

  return (
    <>
      <DialogHeader
        title={translation.successDialog.title}
        handleClose={handleClose}
        isClosable={true}
      />
      <DialogContent sx={{ display: "flex", width: "-webkit-fill-available" }}>
        <DialogContentText
          id="alert-dialog-description"
          className="intelligent-profile-dialog-text"
          marginBottom={4}
          display={"flex"}
          fontWeight={"bold"}
          fontSize={"1.1em"}
          color={"textPrimary"}
        >
          {translation.successDialog.description}
        </DialogContentText>
      </DialogContent>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        margin={3}
      >
        <Button
          className="intelligent-profile-dialog-button"
          variant="contained"
          onClick={handleClick}
          data-dtm="exhibitorHub_smartCompanion_DiscoverProfile"
        >
          {translation.successDialog.button}
        </Button>
      </Stack>
    </>
  );
}
